import GLFX from 'glfx'
import { loadImage } from './loadImageByPromise'
import CONST from './const'
import Example8 from './three/2dCameraCurtainTest'

let three_js_render;

export default (()=> {
    return (async function getTransformedImage(img_info) {
        if (img_info.item_type === CONST.ITEM_TYPE_CURTAIN) {
            //カーテン
            return await createCurtainImage(img_info);
        } else {
            //壁紙、床材
            return await test(img_info);
        }
    })
})()

function transformImage(texture, img_info) {
    const cv = GLFX.canvas();
    const tx = cv.texture(texture);
    cv.draw(tx).update();

    const start_points = [
        0, 0,
        cv.width, 0,
        0, cv.height,
        cv.width, cv.height
    ];
    const end_points = [
        img_info.top_left.x, img_info.top_left.y,
        img_info.top_right.x, img_info.top_right.y,
        img_info.bottom_left.x, img_info.bottom_left.y,
        img_info.bottom_right.x, img_info.bottom_right.y
    ];

    cv.draw(tx).perspective( start_points, end_points ).update();

    return cv;
}

function clippingImage(image, img_info) {
    const cv = document.createElement('canvas');
    cv.width = img_info.width;
    cv.height = img_info.height;

    const ctx = cv.getContext('2d');
    ctx.drawImage(image, 0, 0);
    ctx.globalCompositeOperation = 'destination-in';
    ctx.fillStyle = 'rgb(0, 0, 0)';
    ctx.beginPath();
    ctx.moveTo(img_info.top_left.x, img_info.top_left.y);
    ctx.lineTo(img_info.top_right.x, img_info.top_right.y);
    ctx.lineTo(img_info.bottom_right.x, img_info.bottom_right.y);
    ctx.lineTo(img_info.bottom_left.x, img_info.bottom_left.y);
    ctx.fill();

    return cv;
}

async function createTexture(img_info) {
    const cv = document.createElement('canvas');

    try{
        const is_check_pattern = (img_info.is_check_pattern && img_info.item_data.can_itimatsu) ? '_itimatsu' : '';
        const prefix = img_info.prefix ? `${img_info.prefix}/` : '';

        //画像の読み込み
        const img = await loadImage(`item_image/${img_info.item_type}/repeat/${prefix}${img_info.item_data.name}${is_check_pattern}.jpg`);

        //item_data.width、item_data.heightはテクスチャの情報（CSV参照）
        //rect_widthは選択範囲横幅の実寸
        const ratio = img_info.rect_width / img_info.item_data.width;
        const ratio2 = img_info.item_data.width / img_info.item_data.height;

        //img_info.widthはcanvas上の枠線の幅
        cv.width = img_info.width / ratio;
        cv.height = cv.width / ratio2;

        const ctx = cv.getContext('2d');
        ctx.drawImage(img, 0, 0, img.width, img.height, 0, 0, cv.width, cv.height);

        return cv;

    } catch {
        cv.width = 500;
        cv.height = 500;
        const ctx = cv.getContext('2d');
        ctx.fillStyle = 'aqua';
        ctx.fillRect(0,0,cv.width,cv.height);
        return cv;
    }
}

function pickupImageSize(filename) {
    const matches = /タテ((\d|\.)+)ヨコ((\d|\.)+)\.jpg/g.exec(filename);
    return [
        matches[1] || 10,
        matches[3] || 10
    ]
}

async function test(info) {
    const texture = await createTexture(info);

    const default_value = {
        top_left    : {x: 0, y: 0},
        top_right   : {x: 0, y: 0},
        bottom_left : {x: 0, y: 0},
        bottom_right: {x: 0, y: 0},
    };
    const tp = info.perspective || default_value;
    const adjust = calc(tp);

    const image = (() => {
        const cv = document.createElement('canvas');
        cv.width = info.width + adjust.width; cv.height = info.height + adjust.height;
        const ctx = cv.getContext('2d');
        ctx.beginPath();
        ctx.fillStyle = ctx.createPattern(texture, 'repeat');
        ctx.rect(0,0,cv.width,cv.height);
        ctx.fill();
        return cv
    })();

    const transformed_image = (() => {
        const cv = GLFX.canvas();
        const tx = cv.texture(image);
        cv.draw(tx).update();

        const start_points = [
            adjust.left - tp.top_left.x, adjust.top - tp.top_left.y,
            info.width + adjust.left - tp.top_right.x, adjust.top - tp.top_right.y,
            adjust.left - tp.bottom_left.x, info.height + adjust.top - tp.bottom_left.y,
            info.width + adjust.left - tp.bottom_right.x, info.height + adjust.top - tp.bottom_right.y
        ];
        const end_points = [
            info.top_left.x, info.top_left.y,
            info.top_right.x, info.top_right.y,
            info.bottom_left.x, info.bottom_left.y,
            info.bottom_right.x, info.bottom_right.y
        ];

        cv.draw(tx).perspective( start_points, end_points ).update();
        return cv;
    })();

    const cv2 = ((image, img_info) => {
        const cv = document.createElement('canvas');
        cv.width = img_info.width;
        cv.height = img_info.height;

        // const point1 = img_info.perspective || { ...img_info };
        // const point2 = { ...img_info };
        // const cnt1 = CalcScale.getCentroid(point1);
        // const cnt2 = CalcScale.getCentroid(point2);

        const ctx = cv.getContext('2d');
        ctx.drawImage(image, 0, 0);
        //ctx.drawImage(image, cnt2.x - cnt1.x, cnt2.y - cnt1.y);
        ctx.globalCompositeOperation = 'destination-in';
        ctx.fillStyle = 'rgb(0, 0, 0)';
        ctx.beginPath();
        ctx.moveTo(img_info.top_left.x, img_info.top_left.y);
        ctx.lineTo(img_info.top_right.x, img_info.top_right.y);
        ctx.lineTo(img_info.bottom_right.x, img_info.bottom_right.y);
        ctx.lineTo(img_info.bottom_left.x, img_info.bottom_left.y);
        ctx.fill();

        return cv;
    })(transformed_image, info);


    return cv2
    // const el = await loadImage(cv2.toDataURL());
    // document.body.appendChild(el);
}

function calc(points) {
    const left = Math.max( ((points.top_left.x > 0) ? points.top_left.x : 0), ((points.bottom_left.x > 0) ? points.bottom_left.x : 0) );
    const right = Math.max( Math.abs((points.top_right.x < 0) ? points.top_right.x : 0), Math.abs((points.bottom_right.x < 0) ? points.bottom_right.x : 0) );
    const width = left + right;

    const top = Math.max( ((points.top_left.y > 0) ? points.top_left.y : 0), ((points.top_right.y > 0) ? points.top_right.y : 0) );
    const bottom = Math.max( Math.abs((points.bottom_left.y < 0) ? points.bottom_left.y : 0), Math.abs((points.bottom_right.y < 0) ? points.bottom_right.y : 0) );
    const height = top + bottom;

    return {left, top, width, height};
}

//メインの処理
async function createCurtainImage(img_info) {
    //WebGLのコンテキストの数はブラウザに制限されているため何度もnewしない
    if (!three_js_render) three_js_render = new Example8();

    //three.jsでカーテンを生成してimg要素に変換する
    const img = await three_js_render.start(img_info);

    //three.jsで生成した画像の表示（開発用）
    // if (process.env.NODE_ENV === 'development') {
    //     img.style.border = '1px solid #999';
    //     img.style.marginRight = '5px';
    //     document.body.appendChild(img);
    // }

    //glfxで画像を歪ませる
    let cv = await transformImage(img, img_info);
    cv = await clippingImage(cv, img_info);

    //img要素にして返す
    return loadImage(cv.toDataURL('image/png'));
}
